import React from 'react';

import Button, { ButtonSize, ButtonType } from '@/components/commons/button';
import FaceGrinStars from '@/components/commons/icons/FaceGrinStars';

function NoQuestions({
    closeModal,
}) {
    return (
        <div className="relative w-[450px] h-full bg-cirrusWhite rounded-lg">
            <div className="p-6 text-gray-600">
                <FaceGrinStars className="inline align-middle" />
                <span className="font-medium text-[18px] inline align-middle">
                    &nbsp;
                    You’re caught up!
                </span>
            </div>
            <hr />
            <div className="p-6">
                You’ve answered all the questions we had about your contacts and relationships.
                Well done!
                <center className="pt-8">
                    <Button
                        onClick={closeModal}
                        type={ButtonType.secondary}
                        text="Okay"
                        size={ButtonSize.large}
                    />
                </center>
            </div>
        </div>
    );
}

export default NoQuestions;
